export default __webpack_public_path__ + "static/media/androidgame.f3547b97.png";